import styled from 'styled-components';

const SelectLabel = styled.label`
  display: ${props => {
  var _a;

  return (_a = props.display) !== null && _a !== void 0 ? _a : 'inline-flex';
}};
  position: relative;
`;

export { SelectLabel };
